import api from '@/apis/di/activityAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('activity', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_activity',
    field: {
      key: 'activity_id',
      code: 'activity_code',
      name: 'activity_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
